import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from 'antd';
import GridContainer from '../global/GridContainer/GridContainer';
import Button from '../global/Button';
import { TranslateApi } from '../../api';
import TextField from '../global/fields/TextField';


const TranslationTool = () => {
  const [descriptionFrom, setDescriptionFrom] = useState({});
  const [descriptionTo, setDescriptionTo] = useState({});
  const [language, setLanguage] = useState('en');
  const [supportedLanguages, setSupportedLanguages] = useState([]);
  const [selectActive, setSelectActive] = useState(false);
  const [copied, setCopied] = useState(false);

  const dropdown = useRef(null);


  const getSupportedLanguages = async() =>{
    const result = await TranslateApi.getSupportedLanguages()

    if (result && result.success) {
      setSupportedLanguages(result.data)
    }
  }

  useEffect(() => {
    getSupportedLanguages()
  }, []);

  const onTranslate = async () => {
    const result = await TranslateApi.getTranslation(language, descriptionFrom.value)
    setDescriptionTo({value: result.data})
  }

  const renderOptions = (data) => {
    const options = [];

    for (let i = 0; i < data.length; i++) {
      options.push(
        <Select.Option key={`lengthDur:${data[i].value}`} value={data[i].value}>
          <div className='create-feed-select-dropdown-option'>
            {data[i].label}
          </div>
        </Select.Option>,
      );
    }

    return options;
  }

  const onSupportedLanguageChange = (newValue) => {
    setLanguage(newValue);
    dropdown.current.blur();
  };

  const onCopyToClipboard = () => {
    setCopied(true);

    navigator.clipboard.writeText(descriptionTo.value)

    setTimeout(() => {
      setCopied(false)
    }, 500)
  }

  return (
    <div className="communities-container create-feed">
      <GridContainer>
        <div className="communities-container--upper">
          <h3 className="title m-0">Translation tool</h3>
        </div>
        <div className="pt-3">
          <TextField
            key={"descriptionFrom"}
            fk={"descriptionFrom"}
            type={"textarea"}
            label={"From"}
            fieldTag={"textarea"}
            rows={4}
            value={descriptionFrom.value}
            validateRule={'max500'}
            validateObj={{ ['max500']: descriptionFrom.value }}
            error={descriptionFrom.error}
            showError={true}
            updateFieldData={(fk, value, error) => setDescriptionFrom({ value, error })}
            triggerOnChange
          />
        </div>

        <div className="pt-3">
          <TextField
            key={"descriptionTo"}
            fk={"descriptionTo"}
            type={"textarea"}
            label={"To"}
            fieldTag={"textarea"}
            rows={4}
            readOnly={true}
            value={descriptionTo.value}
            updateFieldData={(fk, value, error) => setDescriptionTo({ value, error })}
          />
          <div className="d-flex w-100 justify-content-end m-0 p-0">
            {copied ? <p className='m-0 p-0 pr-3'>Copied translation</p> : null}
            <button className={'btn shadow-none m-0 p-0'} disabled={!descriptionTo.value} onClick={onCopyToClipboard}>
              <FontAwesomeIcon icon={'copy'} style={{color: descriptionTo.value ? "#20aca3" : "#9c9c9c"}} />
            </button>
          </div>
        </div>

        <div className='create-feed-translation-holder'>
          <span
            className={`create-feed-select-label ${
              selectActive || language ? 'active' : ''
            }`}
            onClick={() => dropdown.current.focus()}
          >
            Supported languages
          </span>
          <Select
            ref={(ref) => {
              dropdown.current = ref;
            }}
            value={language}
            onChange={onSupportedLanguageChange}
            className='create-feed-select'
            showArrow={false}
            dropdownClassName='create-feed-select-dropdown'
            defaultActiveFirstOption={false}
            open={selectActive}
            onFocus={() => setSelectActive(true) }
            onBlur={() => setSelectActive(false) }
          >
            {renderOptions(supportedLanguages)}
          </Select>

          <FontAwesomeIcon className='create-feed-select-icon' icon={['fas', 'chevron-down']} />
        </div>
        <div className="d-flex">
            <div className="create-feed-post-button">
            <Button.Primary onClick={onTranslate} disabled={!descriptionFrom.value || !language || descriptionFrom.error}>
              Translate
            </Button.Primary>
          </div>
        </div>
        <p className="pt-3 font-italic">
          Using the Application with a language other than English, we will use an external translation service (Google Translate). Information processed via the translation service might be subject to inaccurate translation.
        </p>
      </GridContainer>
    </div>
  );
};

export default TranslationTool;
